import { ReactNode } from "react";

import { IgLink, IgTypography } from "@intelligems/ig-theme";
import { Stack, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { GridProps } from "@mui/system";
import { contactSupport } from "@src/utils/contactSupport";

type ErrorHandlerProps = {
  actionText?: ReactNode;
  height?: number;
  text?: ReactNode;
} & GridProps;

export const ErrorHandler = ({
  actionText,
  height = 350,
  text,
  ...props
}: ErrorHandlerProps) => {
  const theme = useTheme();

  const DEFAULT_ACTION_TEXT = (
    <>
      Please try reloading the page or{" "}
      <IgLink onClick={contactSupport}>contact our support team.</IgLink>
    </>
  );

  const DEFAULT_TEXT = <>An error occurred while loading your data.</>;

  return (
    <Grid
      container
      sx={{
        minHeight: height,
      }}
    >
      <Stack
        alignItems="center"
        gap={1}
        justifyContent="center"
        sx={{ width: "100%" }}
      >
        <IgTypography sx={{ color: theme.palette.secondary.main }}>
          {text ?? DEFAULT_TEXT}
        </IgTypography>

        <IgTypography sx={{ color: theme.palette.secondary.main }}>
          {actionText ?? DEFAULT_ACTION_TEXT}
        </IgTypography>
      </Stack>
    </Grid>
  );
};
